export enum Currency {
    UAH,
    USD,
    EUR,
}
